import * as React from 'react';

import UserSettings16 from './UserSettings16';

export const userSettings16 = () => <UserSettings16 />;

export default {
    title: 'Icon/Fill/UserSettings16',
    component: UserSettings16,
    parameters: {
        notes: "`import UserSettings16 from 'box-ui-elements/es/icon/fill/UserSettings16';`",
    },
};
